export default __webpack_public_path__ + "static/media/webiner_coach3.3e239349.jpg";